import React from 'react';
import {useNavigate} from 'react-router';
import {CreatePublicServiceConsentRequest} from '@di-shared/api/di/__generated';
import Header from '@di-shared/features/common/Header';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import LottieSelector from '@di-shared/features/common/LottieSelector';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {useEnvironmentStore} from '@di-shared/features/environment/environmentStore';
import {ROUTE_PATHS} from '@di-shared/routes';
import {DotLottieReact} from '@lottiefiles/dotlottie-react';

interface VehicleInspectionAboutPageProps {
  vin: string;
}

function VehicleInspectionAboutPage({vin}: VehicleInspectionAboutPageProps) {
  const {t} = useInferableTranslation();
  const navigate = useNavigate();
  const lang = useEnvironmentStore((state) => state.lang);

  function goToPublicServiceAgreePage() {
    navigate(
      ROUTE_PATHS.PUBLIC_SERVICE_CONSENTS_$CATEGORY.getFullPath({
        vin,
        category: CreatePublicServiceConsentRequest.category.VEHICLE_INSPECTION,
        nextUrl: ROUTE_PATHS.PUBLIC_SERVICE_VEHICLE_INSPECTION_NEW.getFullPath(vin),
      }),
      {replace: true}
    );
  }

  return (
    <div className="wrap">
      <ScrollToTopOnMount />
      <Header left={<HeaderBackButton />}>
        <h1 className="headline_xxsmall nav_center_title">{t('T30548')}</h1>
      </Header>
      <main
        id="content"
        className="content"
      >
        <section className="section section_vehicle_intro car_inspection">
          <section className="section">
            <div className="intro_heading">
              <h2
                className="intro_heading_title"
                style={{whiteSpace: 'pre-wrap'}}
              >
                {t('T30549')}
              </h2>
              <p className="intro_desc">{t('T30550')}</p>
            </div>
            <div className="intro_motion">
              <div className="intro_imgbox">
                <DotLottieReact
                  className={'intro_img'}
                  src={'/assets/lottie/car_inspection_intro_01.lottie'}
                  loop
                  autoplay
                />
              </div>
            </div>
          </section>
          <section className="section">
            <div className="intro_heading">
              <h2
                className="intro_heading_title"
                style={{whiteSpace: 'pre-wrap'}}
              >
                {t('T30551')}
              </h2>
              <p className="intro_desc">{t('T30552')}</p>
            </div>
            <div className="intro_motion">
              <div className="intro_imgbox">
                {/* fixme : eu 버젼 분기 필요*/}

                {lang.includes('ko') ? (
                  <DotLottieReact
                    className={'intro_img'}
                    src={'/assets/lottie/car_inspection_intro_02.lottie'}
                    loop
                    autoplay
                  />
                ) : (
                  <DotLottieReact
                    className={'intro_img'}
                    src={'/assets/lottie/car_inspection_intro_eu_02.lottie'}
                    loop
                    autoplay
                  />
                )}
              </div>
            </div>
          </section>
        </section>
        <section className="section section_notice">
          <div className="section_container">
            <strong className="notice_title">{t('T30553')}</strong>
            <ul className="notice_list">
              <li className="notice_item">{t('T30554')}</li>
              <li className="notice_item">{t('T30555')}</li>
              <li className="notice_item">{t('T30556')}</li>
            </ul>
          </div>
        </section>
      </main>

      <div className="floating_action_area">
        <button
          type="button"
          className="btn btn_large btn_filled btn_full"
          onClick={() => goToPublicServiceAgreePage()}
        >
          {t('T10218')}
        </button>
      </div>
    </div>
  );
}

export default VehicleInspectionAboutPage;
